var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.297,
    height: 13.321,
    viewBox: "0 0 12.297 13.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(-638.7 -223.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0,6.66,6.661,13.321,0Z",
    transform: "translate(650.997 223.305) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M310.824,876.348l-4.429,4.428,4.429,4.428-1.348,1.348-5.777-5.776L309.477,875Z",
    transform: "translate(335 -650.822)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.89bb9de868f5ee6734ca156aa895f9ba.svg";
export { ForwardRef as ReactComponent };